import React, { useState, useEffect, useCallback } from "react";
import { Card } from "react-bootstrap";
import ListOfSubSlides from "./ListOfSubSlides";
import { Draggable } from "react-drag-reorder";
import "../css/listOfSlides.scss";
import CircularProgressBar from "../utils/CircularProgressBar";
// import "../css/common.scss";
import CheckMarkIconWhite from "../images/CheckMarkIconWhite.svg";
import DragIndicatorIcon from "../images/drag-indicator-pdf-flow.svg";

import { createNewPageUpdate, geteDetailByID } from "../services/apis";

const ListOfSlides = ({
  data,
  setSwapped,
  slideID,
  setSlideID,
  setSaveLoading,
  selectedCardHandler,
  slidesData,
  currentSlideId,
  slideIndex,
  isPdfFlow = false,
}) => {
  const [selectSlideID, setSelectSlideId] = useState();
  const [isloading, setIsloading] = useState(false);
  useEffect(() => {
    setSwapped(false);
    // setSaveLoading(false);
  }, []);
  const imageLoaded = (parentId, thumbnail) => {
    const id = document.getElementById(`${parentId}`);
    const card = id.getElementsByClassName("p-slide");
    card[0].lastChild.remove();
  };
  const getChangedPos = (from, to) => {
    if (to === from || slideID.length < 2) return;
    let reOrderedList = JSON.parse(JSON.stringify(slideID));
    reOrderedList.splice(to, 0, reOrderedList.splice(from, 1)[0]);
    let slides = reOrderedList.map((item, index) => ({
      index: index + 1,
      slideid: item?.slideid?._id,
      children: item.children,
    }));
    let slideids = reOrderedList.map((item, index) => ({
      ...item,
      index: index + 1,
    }));
    setIsloading(true);
    setSlideID(slideids);
    createNewPageUpdate(
      data._id,
      { slides: slides },
      (response, err, errorCode) => {
        if (err) {
          return err;
        } else {
          setSwapped(true);
          return response;
        }
      }
    );
    setIsloading(false);
  };
  const [id, setID] = useState(null);

  const getActiveClassStatus = (id, currentid) => {
    if (id == currentid) {
      return true;
    } else {
      return false;
    }
  };

  const eventHandlerHighlight = (e, eleId) => {
    //console.log(e, "event");
    const id = document.getElementById(`${eleId}`);
    const ig = id.getElementsByTagName("img")[0]; //.getAttribute("data-drag-id");
    const classExist = document.querySelectorAll(".selected-card");
    if (ig.classList.contains("selected-card")) {
      ig.classList.add("inactive");
      ig.classList.remove("selected-card");
      ig.closest(".slides-container").classList.remove("selected-slide");
    } else {
      classExist.forEach((element) => {
        element.classList.remove("selected-card");
        element.closest(".slides-container").classList.remove("selected-slide");
      });
      ig.classList.add("selected-card");
      ig.classList.remove("inactive");
      ig.closest(".slides-container").classList.add("selected-slide");
    }

    // console.log(ig, eleId, 'currentid');
  };

  const MasterSlidesData = useCallback(() => {
    return (
      <Draggable onPosChange={getChangedPos}>
        {slideID?.length > 0 &&
          slideID?.map((el, index) => {
            const imageKey = Date.now(); //Math.floor(Math.random() * 10);
            // console.log(id, el.slideid._id);
            let x = true;
            return (
              <div
                className="slides-container"
                key={el.slideid._id}
                data-drag-id={el.slideid._id}
                id={el.slideid._id}
                onClick={
                  isPdfFlow
                    ? undefined
                    : (e) => {
                        setID(el?.slideid._id);
                        eventHandlerHighlight(e, el.slideid._id);
                        selectedCardHandler(data, el?.slideid?._id, el?.index);
                      }
                }
                style={isPdfFlow ? { cursor: "default" } : {}}
              >
                {!isPdfFlow && (
                  <div className="slide-checkmark">
                    <img src={CheckMarkIconWhite} alt="✓" />
                  </div>
                )}
                <span className="i-slide"> 
                  <p className="slide-index" style={{textAlign:"center", marginLeft:"8px"}}>
                    {el?.index}.
                    {isPdfFlow && (
                      <img
                        src={DragIndicatorIcon}
                        alt="drag"
                        style={{
                          width: "16px",
                          height: "16px",
                          marginTop: "14px",
                          verticalAlign: "middle",
                          display: "inline-block",
                        }}
                      />
                    )}
                  </p>
                  {!isPdfFlow && (x = getActiveClassStatus(el.slideid._id, id))}
                  <Card className="p-slide">
                    <img
                      className={"inactive"}
                      src={
                        el.slideid?.thumbnailNew !==
                        "https://cdn.link/image.png"
                          ? `${el?.slideid?.thumbnailNew}?n=${imageKey}`
                          : "https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
                      }
                      key={imageKey}
                      alt=""
                      onLoad={(e) =>
                        imageLoaded(el.slideid._id, el?.slideid?.thumbnail)
                      }
                    />

                    <span className="ImageLoaderSpan">Loading...</span>

                    {/*<span>SLIDE {el?.index}</span>*/}
                  </Card>
                </span>
                {el?.children !== 0 ? (
                  <ListOfSubSlides
                    slideData={el?.children}
                    parentSlideId={el?.index}
                    selectedCardHandler={selectedCardHandler}
                  />
                ) : null}
              </div>
            );
          })}
      </Draggable>
    );
  }, [slideID]);

  return (
    <>
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div className="slidesList customScrollBar">{<MasterSlidesData />}</div>
    </>
  );
};
export default ListOfSlides;
